import { StarIcon } from 'lucide-react'

type Review = {
  quote: string
  author: string
}

const REVIEWS: Review[] = [
  {
    quote:
      'De glutenvrije cursus van Esmee heeft mij enorm geholpen om beter te begrijpen hoe ik mijn glutenvrije eetpatroon effectief kan aanpakken. De uitleg is helder, overzichtelijk en prettig om te volgen. Daarnaast zijn de bijgevoegde documenten een waardevolle aanvulling die alles nog duidelijker maken. Ik raad deze cursus zeker aan aan iedereen die praktische handvatten zoekt om volwaardig glutenvrij te eten.',
    author: 'Kelly',
  },
  {
    quote:
      'Zeer prettige en deskundige begeleiding bij mijn dochter van 15 jr met Coeliakie en overprikkelde darmen. Esmee kwam met veel praktische, vezelrijke maar toch smaakvolle adviezen.',
    author: 'Lisette',
  },
]

const Stars = () => (
  <div className="flex items-center gap-0.5" aria-label="5 van de 5 sterren">
    {Array.from({ length: 5 }).map((_, i) => (
      <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" />
    ))}
  </div>
)

export const CourseReviews = ({ className }: { className?: string }) => {
  return (
    <section className={className} aria-label="Reviews">
      <div className="mb-6 flex items-center justify-between gap-3">
        <h3 className="text-xl font-bold text-foreground">Wat cursisten zeggen</h3>
        <div className="flex items-center gap-2">
          <Stars />
          <span className="text-sm font-medium text-muted-foreground">5,0</span>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {REVIEWS.map((review) => (
          <figure
            key={review.author}
            className="flex flex-col gap-4 rounded-2xl border border-border/60 bg-card/50 p-6 shadow-sm"
          >
            <Stars />
            <blockquote className="flex-1 text-sm leading-relaxed text-foreground/80">
              &ldquo;{review.quote}&rdquo;
            </blockquote>
            <figcaption className="flex items-center gap-3">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-semibold text-primary">
                {review.author.charAt(0)}
              </div>
              <span className="text-sm font-semibold text-foreground">{review.author}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  )
}
